const reverse = <T>(array?: Array<T>) => {
  if (!array) return undefined
  return [...array].reverse()
}

export const ArrayUtils = {
  reverse,
}
